var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "selection" }, [
    _c("header", [
      _c(
        "div",
        { staticClass: "selection-details" },
        [
          _c(
            "h2",
            { on: { click: _vm.toggleMinified } },
            [
              _c("span", { staticClass: "selection-number" }, [
                _vm._v(_vm._s(_vm.index) + "."),
              ]),
              _vm._v("\n        " + _vm._s(_vm.selection.title) + "\n        "),
              _vm.minified && _vm.noItems
                ? [
                    _vm._v(
                      "\n          / " + _vm._s(_vm.noItems) + "\n        "
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.minified && _vm.frequency
                ? [
                    _vm._v(
                      "\n          every " +
                        _vm._s(_vm.frequency) +
                        "\n        "
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.minified && _vm.selectionPrice
                ? [
                    _vm._v(
                      "\n          / A$ " +
                        _vm._s(_vm.selectionPrice) +
                        "\n        "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-fade" } },
            [
              !_vm.minified
                ? [
                    _c("div", { staticClass: "flex-container" }, [
                      _c(
                        "div",
                        { staticClass: "description-container" },
                        [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.selection.abstract),
                            },
                          }),
                          _vm._v(" "),
                          _vm.selection.body
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-outline-primary btn-small",
                                    attrs: { href: "javascript:" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleMore("body")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Read\n                  "
                                    ),
                                    _vm.showMore.body
                                      ? [_vm._v("Less\n                  ")]
                                      : [_vm._v("More")],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.showMore.body
                                      ? [
                                          _c("p", {
                                            staticClass: "more-text",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.selection.body
                                              ),
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("section", { staticClass: "cta-container" }, [
                            _vm.selectionPrice
                              ? _c(
                                  "div",
                                  { staticClass: "selection-price" },
                                  [
                                    !_vm.customClub
                                      ? [
                                          _vm.selectionRRP
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "price-rrp strike-through",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "currency",
                                                      },
                                                      [_vm._v("A$")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "amount" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.selectionRRP
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          title:
                                                            "Recommended Retail Price",
                                                        },
                                                      },
                                                      [_vm._v("RRP")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "currency" },
                                            [_vm._v("A$")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "amount" },
                                            [_vm._v(_vm._s(_vm.selectionPrice))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "frequency" },
                                            [
                                              _vm._v(
                                                "\n                      Get "
                                              ),
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.noItems)),
                                              ]),
                                              _vm._v(
                                                "\n                      every "
                                              ),
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.frequency)),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                    Choose "
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.noItems)),
                                          ]),
                                          _vm._v(
                                            " from our finest wines and\n                    get them delivered every "
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.frequency)),
                                          ]),
                                          _vm._v(
                                            " to your home\n                    and save.\n                  "
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "join-club" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "btn btn-cta btn-primary btn-large",
                                    attrs: {
                                      to: `/wine-club/preselect/${_vm.selection.id}`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Join This Club\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "side-container" }, [
                        _vm.discount
                          ? _c("div", { staticClass: "discount" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  "\n                  Discount\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "amount" },
                                [
                                  _vm.discountIsPercent
                                    ? [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.discount) +
                                            " %\n                  "
                                        ),
                                      ]
                                    : [
                                        _c("div", { staticClass: "price" }, [
                                          _c(
                                            "span",
                                            { staticClass: "currency" },
                                            [_vm._v("A$")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "amount" },
                                            [_vm._v(_vm._s(_vm.discount))]
                                          ),
                                        ]),
                                      ],
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "shipping-schedule-headline" },
                          [_c("h4", [_vm._v("Shipping Schedule")])]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "selection-dates-timeline" }, [
                          _c("ul", [
                            _c(
                              "li",
                              {
                                class: {
                                  passed: _vm.checkDatePassed(
                                    _vm.selection.lastshippeddate
                                  ),
                                },
                              },
                              [
                                _c("span", { staticClass: "date" }, [
                                  _vm._v(_vm._s(_vm.lastShippedDate)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Previous Shipping"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                class: {
                                  passed: _vm.checkDatePassed(
                                    _vm.selection.lockdate
                                  ),
                                },
                              },
                              [
                                _c("span", { staticClass: "date" }, [
                                  _vm._v(_vm._s(_vm.lockedByDate)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Cut off Date"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                class: {
                                  passed: _vm.checkDatePassed(
                                    _vm.selection.processingdate
                                  ),
                                },
                              },
                              [
                                _c("span", { staticClass: "date" }, [
                                  _vm._v(_vm._s(_vm.processingDate)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Orders being processed"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                class: {
                                  passed: _vm.checkDatePassed(
                                    _vm.selection.nextshippeddate
                                  ),
                                },
                              },
                              [
                                _c("span", { staticClass: "date" }, [
                                  _vm._v(_vm._s(_vm.nextShippedDate)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Upcoming Shipping"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "selection-dates" }, [
                          _c("div", { staticClass: "date-container" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("Frequency:"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "date" }, [
                              _vm._v(_vm._s(_vm.frequency)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    !_vm.minified && !_vm.customClub
      ? _c("div", { staticClass: "products-wrapper" }, [
          _c("h2", { staticClass: "products-headline" }, [
            _vm._v("\n      Products in this Selection\n    "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "products-container" },
            _vm._l(_vm.combinedProducts, function (item, index) {
              return _c("Product", {
                key: index,
                attrs: { product: item, "custom-club": _vm.customClub },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }